import { HttpHeaders } from '@angular/common/http';



//export const APP_VERSION = require('../../../../package.json').version;

 export const DEBUG_ENVIRONMENT =   (window.location.href.indexOf("localhost") > -1);

 export const API_ADDRESS_PRODUCTION =  (window.location.href.indexOf("spolti") > -1)?
      'https://www.spolti.com.br/ore/webApi/api':'https://ssl.intellitools.com.br/ore/webApi/api';

 export const API_ADDRESS_DEBUG= "http://localhost:54524/api"

 export const API_ADDRESS =   DEBUG_ENVIRONMENT?API_ADDRESS_DEBUG:API_ADDRESS_PRODUCTION;

 export const ADMIN_EMAILS = ["andre@spolti.com.br"] 

   
 export const httpOptionsDefault = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',

    })
  };


